import * as React from "react";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { IBaseInputProps } from "../../../../../interfaces/advancedSearch/IBaseInputProps";
import { LanguageContext } from "../../../../../../../utilities/LocalizationModule";

export const YesNoFieldInput: React.FunctionComponent<IBaseInputProps> = props => {
  const languageStrings = React.useContext(LanguageContext);

  React.useEffect(() => {
    setChecked(props.searchInputData?.value == "1" ? true : false);
  }, []);

  const [isChecked, setChecked] = React.useState(true);
  const handleOnChange = (event: any, checked: boolean) => {
    let value = checked ? "1" : "0";
    props.handleValueChange(props.searchInputData?.index, value);
    setChecked(checked);
  };

  return (
    <Toggle
      label={props.displayName}
      checked={isChecked}
      onText={languageStrings.Yes}
      offText={languageStrings.No}
      onChange={handleOnChange}
      role="checkbox"
      className="xb-sp-input"
    />
  );
};

export default YesNoFieldInput;
